import { useEffect } from "react";
import { X } from "lucide-react";
import { SmartImage } from "@ec2/ui";
import { useT } from "@ec2/i18n/react";
import { appConfig } from "../lib/config";

/**
 * Full-screen view of one image (quiz question/answer pictures). Leaving is
 * deliberately easy: the X, a tap anywhere, or Escape.
 */
export function ImageLightbox({ mediaKey, onClose }: { mediaKey: string; onClose: () => void }) {
  const t = useT();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={t("ec2.quiz.imageLarge")}
      data-testid="ec-image-lightbox"
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-3 pt-[calc(env(safe-area-inset-top)+3.5rem)] pb-[calc(env(safe-area-inset-bottom)+1rem)]"
    >
      <button
        type="button"
        onClick={onClose}
        aria-label={t("ec2.common.close")}
        data-testid="ec-image-lightbox-close"
        className="absolute right-3 top-[calc(env(safe-area-inset-top)+0.75rem)] flex size-11 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur focus-visible:outline-2 focus-visible:outline-white"
      >
        <X size={24} aria-hidden />
      </button>
      <SmartImage
        base={appConfig.mediaBase}
        mediaKey={mediaKey}
        alt=""
        width={1600}
        height={1600}
        maxVariant="full"
        className="max-h-full max-w-full object-contain"
      />
    </div>
  );
}
